import React from 'react';
import { Box, VStack, HStack, Text, Image, Icon, Flex } from '@chakra-ui/react';
import { FiUsers, FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { Room } from '../../api/rooms/types';
import { useTranslation } from '../../hooks/useTranslation';
import Button from '../base/Button';

interface MeetingRoomCardProps {
    room: Room;
    bookingPath: string;
}

const MeetingRoomCard: React.FC<MeetingRoomCardProps> = ({ room, bookingPath }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleBook = () => {
        navigate(`${bookingPath}?roomId=${room.id}`);
    };

    return (
        <Box
            bg="white"
            overflow="hidden"
            maxW="600px"
            _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}
            transition="all 0.2s ease-in-out"
            onClick={handleBook}
        >
            <Flex direction={{ base: 'column', md: 'row' }} align="stretch" gap={0}>
                {/* Картинка */}
                <Box
                    w={{ base: 'full', md: '250px' }}
                    h="200px"
                    bg="gray.200"
                    position="relative"
                    overflow="hidden"
                    flexShrink={0}
                >
                    <Image src={room.image_links[0]} alt={room.name} w="full" h="full" objectFit="cover" />
                </Box>

                {/* Контент */}
                <VStack align="stretch" gap={3} p={4} flex={1}>
                    {/* Название */}
                    <Text fontSize="xl" fontWeight="bold" color="black">
                        {room.name}
                    </Text>

                    {/* Описание с вместимостью */}
                    <VStack align="stretch" gap={2}>
                        <Text fontSize="md" color="gray.600">
                            {room.description}
                        </Text>
                        <HStack gap={2} align="center">
                            <Icon as={FiUsers} boxSize={4} color="black" />
                            <Text fontSize="sm" color="black" fontWeight="bold">
                                {t.pages.office.capacity}: {room.capacity} {t.pages.office.people}
                            </Text>
                        </HStack>
                    </VStack>

                    {/* Цена */}
                    <Text fontSize="lg" fontWeight="bold" color="yellow.600">
                        {t.pages.office.fromPrice} €{room.price} {t.pages.office.perHour}
                        {', '}
                        {t.pages.office.exclVat}
                    </Text>

                    {/* Кнопка "Забронировать" */}
                    <Button buttonType="success" onClick={handleBook} w="full">
                        <HStack gap={2} justify="center">
                            <Text>{t.pages.office.book}</Text>
                            <Icon as={FiArrowRight} boxSize={4} />
                        </HStack>
                    </Button>
                </VStack>
            </Flex>
        </Box>
    );
};

export default MeetingRoomCard;
